module.exports = __webpack_public_path__ + "img/bio.bd2050c0.png";